import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import ApplicantTrackingCRMBuildClientSection from '~/components/LandingPage/ApplicantTrackingCRMBuildClientSection'
import ApplicantTrackingCRMExploreSection from '~/components/LandingPage/ApplicantTrackingCRMExploreSection'
import ApplicantTrackingCRMIntegratedSaveTimeSection from '~/components/LandingPage/ApplicantTrackingCRMIntegratedSaveTimeSection'
import ApplicantTrackingCRMIntegratedSection from '~/components/LandingPage/ApplicantTrackingCRMIntegratedSection'
import ApplicantTrackingCRMJoinSection from '~/components/LandingPage/ApplicantTrackingCRMJoinSection'
import ApplicantTrackingCRMSimpleEffectiveSection from '~/components/LandingPage/ApplicantTrackingCRMSimpleEffectiveSection'
import ApplicantTrackingCRMWorkEfficientlySection from '~/components/LandingPage/ApplicantTrackingCRMWorkEfficientlySection'
import JourneySection from '~/components/LandingPage/JourneySection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'

const ApplicantTrackingCRMContainer: FC = () => {
  return (
    <LayoutLandingPage animationOffset={1400}>
      <ApplicantTrackingCRMSimpleEffectiveSection />

      <LazyLoad height={300} once>
        <ApplicantTrackingCRMBuildClientSection />
      </LazyLoad>

      <LazyLoad height={300} once>
        <ApplicantTrackingCRMIntegratedSaveTimeSection />
      </LazyLoad>

      <LazyLoad height={300} once>
        <ApplicantTrackingCRMIntegratedSection />
      </LazyLoad>

      <LazyLoad height={300} once>
        <ApplicantTrackingCRMWorkEfficientlySection />
      </LazyLoad>

      <LazyLoad height={300} once>
        <ApplicantTrackingCRMJoinSection />
      </LazyLoad>

      <LazyLoad height={300} once>
        <ApplicantTrackingCRMExploreSection />
      </LazyLoad>

      <LazyLoad height={300} once>
        <JourneySection />
      </LazyLoad>
    </LayoutLandingPage>
  )
}

export default ApplicantTrackingCRMContainer
